import apiFetch from '@wordpress/api-fetch';

export function getQuizes (){
  return apiFetch( {
    path: 'https://yazam.sba.org.il/wp-json/wp/v2/quiz?acf_format=standard',
    method: 'GET',
  } ).then(( res ) => {
    return res
  } );
}

export function getFooterMenu (){
  return apiFetch( {

    path: 'https://yazam.sba.org.il/wp-json/wp/v2/menu',
    method: 'GET',
  } ).then(( res ) => {
    return res
  } );
}

export function getFront (){
  return apiFetch( {

    path: 'https://yazam.sba.org.il/wp-json/wp/v2/frontpage',
    method: 'GET',
  } ).then(( res ) => {
    return res
  } );
}

export function getCities (){
  return apiFetch( {

    path: 'https://yazam.sba.org.il/wp-json/wp/v2/api/getCities',
    method: 'GET',
  } ).then(( res ) => {
    return res
  } );
}


export function currentPage (){
  return apiFetch( {

    path: 'https://yazam.sba.org.il/wp-json/wp/v2/api/currentPage',
    method: 'POST',
    data: { href: window.location.href },
  } ).then(( res ) => {
    return res
  } );
}

export function getCurrentPage (){
  return currentPage().then((id) => {
 
    let url = 'https://yazam.sba.org.il/wp-json/wp/v2/pages/' + id;
    return apiFetch( {

      path: url,
      method: 'GET',
    } ).then(( res ) => {
      return res
    } );
  });


}
export function storeUserInfo ({ results, posts, companyDetail, userId = false, fb_rate = false, fb_mess = false }){

  return apiFetch( {
    path: 'https://yazam.sba.org.il/wp-json/wp/v2/api/addPost',
    method: 'POST',
    data: {
      post_title: companyDetail,
      results,
      recomendation: posts,
      userId,
      fb_rate,
      fb_mess,
   },
  } ).then(( res ) => {
    return res
  } );
}
export function addSubscriber ({ email }){

  return apiFetch( {
    path: 'https://yazam.sba.org.il/wp-json/wp/v2/api/addSubscriber',
    method: 'POST',
    data: {
      email
   },
  } ).then(( res ) => {
    return res
  } );
}
